import React from "react";
import { useDispatch, useSelector } from "react-redux";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { FieldSet, Table } from "@sigeco/tools";
import makeStyles from "@material-ui/core/styles/makeStyles";
import {
  detalleCobranza,
  setOrder,
  onUpdateColumn,
} from "../../../store/movilidad/reportecobranza/actions";
import { closeMessageBox, openMessageBox } from "../../../store/main/actions";
import { sort_by, formatoPeru } from "../../../helpers/commons";
import Modal from "@material-ui/core/Modal";
import Button from "@material-ui/core/Button";
import Icon from "@material-ui/core/Icon";
import { useState } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: "1 1 auto",
    flexDirection: "column",
  },
  tableWrap: {
    flex: "1 1 auto",
  },
  modal: {
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    borderRadius: "15px",
  },
  bot: {
    marginLeft: "10px",
    marginTop: "5px",
  },
  resul: {
    fontSize: "10px !important",
    background: "white",
    textAlign: "Left !important",
  },
  resuld: {
    fontSize: "10px !important",
    textAlign: "Right !important",
    background: "white",
  },
  
  // ── Tablas de info cobranza (cabecera y envío)
  infoTable: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    '& td': {
        fontSize: '10px',
        padding: '4px',
    },
    '@media (max-width: 560px)': {
        '& tr': {
            display: 'block',
            marginBottom: '4px',
            border: 'none',    // ← sin bordes en el tr
        },
        '& td': {
            display: 'block',
            width: '100% !important',
            border: 'none',    // ← sin bordes en el td
            boxSizing: 'border-box',
            textAlign: 'left !important',
        },
        '& td[data-label="true"]': {
            backgroundColor: '#BFD9FF',
            fontWeight: 'bold',
            paddingBottom: '2px',
        },
    },
  },
  // ── Tablas de info banco y operacion
  infoBankTable: {
    width: '100%',
    borderCollapse: 'collapse',
    tableLayout: 'fixed',
    '& td': {
        fontSize: '10px',
        padding: '4px',
    },
    '@media (max-width: 560px)': {
        '& tr': {
            display: 'block',
            marginBottom: '4px',
            border: 'none',    // ← sin bordes en el tr
        },
        '& td': {
            display: 'block',
            width: '100% !important',
            border: 'none',    // ← sin bordes en el td
            boxSizing: 'border-box',
            textAlign: 'left !important',
        },
      "& td[data-label='true']": {
        backgroundColor: "#EBE5B7",
        fontWeight: "bold",
        paddingBottom: "2px",
      },
    },
  },
  // Tabla de documentos: scroll horizontal
  docsTableWrap: {
    overflowX: 'auto',
    width: '100%',
    marginBottom: '20px',
    '& table': {
        borderCollapse: 'collapse',
        minWidth: '400px',
        width: '100%',
    },
  },
  infoValor: {
    backgroundColor: '#FFFFFF',
    color: '#1A2B4A',
    fontSize: '11px',
    fontWeight: 600,
    padding: '5px 8px',
    border: '1px solid #C8D6EE',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
  },
    // ── Badge de estado ───────────────────────────────────────────────────────
    estadoPendiente: {
      display: 'inline-block',
      backgroundColor: '#E8EFFF',
      color: '#0033CC',
      fontSize: '10px',
      fontWeight: 700,
      padding: '1px 8px',
      borderRadius: '10px',
      border: '1px solid #99AAEE',
      whiteSpace: 'nowrap',
    },
    estadoAprobado: {
      display: 'inline-block',
      backgroundColor: '#E5F6EC',
      color: '#1A7F3C',
      fontSize: '10px',
      fontWeight: 700,
      padding: '1px 8px',
      borderRadius: '10px',
      border: '1px solid #90D4A8',
      whiteSpace: 'nowrap',
    },
    estadoRechazado: {
      display: 'inline-block',
      backgroundColor: '#FDECEA',
      color: '#C0392B',
      fontSize: '10px',
      fontWeight: 700,
      padding: '1px 8px',
      borderRadius: '10px',
      border: '1px solid #F0A89F',
      whiteSpace: 'nowrap',
    },
    estadoRevisado: {
      display: 'inline-block',
      backgroundColor: '#FEF8E7',
      color: '#9A6D00',
      fontSize: '10px',
      fontWeight: 700,
      padding: '1px 8px',
      borderRadius: '10px',
      border: '1px solid #E8CC80',
      whiteSpace: 'nowrap',
    },
}));

function ReporteCobranzaList(props) {
  const classes = useStyles();
  const [showJsonModal, setShowJsonModal] = useState(false);
  const [, setShowModal] = useState(false);
  const [show, setShow] = useState(false);
  const HandleClose = () => setShow(false);
  const HandleShow = () => setShow(true);

  const columns = useSelector((state) => state.reportecobranza.table.columns);
  const loading = useSelector((state) => state.reportecobranza.loading);
  const order = useSelector((state) => state.reportecobranza.table.order);
  const orderBy = useSelector((state) => state.reportecobranza.table.orderBy);
  const store = useSelector((state) => state.reportecobranza.store);
  const dispatch = useDispatch();

  const handleRequestSort = (property) => {
    const isAsc = orderBy === property && order === "asc";
    dispatch(setOrder(isAsc ? "desc" : "asc", property));
    let homes = store.data;
    homes.sort(sort_by(property, isAsc, homes[0][property]));
  };

  const handleDoubleClick = (item) => {
    let items = [];
    items.push(item);
    dispatch(detalleCobranza(items[0]));
    setShowModal(HandleShow);
  };

  const handleResizeColumn = (column) => {
    dispatch(onUpdateColumn(column));
  };

  const truncateText = (text, maxLength = 150) => {
    if (!text || text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const formatJson = (jsonString) => {
    try {
      if (!jsonString) return "No hay datos";
      const parsed = JSON.parse(jsonString);
      return JSON.stringify(parsed, null, 2);
    } catch (error) {
      return jsonString;
    }
  };

  const HandleOpenJson = () => setShowJsonModal(true);
  const HandleCloseJson = () => setShowJsonModal(false);

  const ModalContent = () => {
    const cobranza = useSelector((state) => state.reportecobranza.store.cobranza);
    const datad = useSelector((state) => state.reportecobranza.store.detalle);

    let total = 0;
    return (
      <div>
        <Modal
          aria-labelledby="simple-modal-title"
          aria-describedby="simple-modal-description"
          open={show}
          onClose={HandleClose}
        >
          <div
            className={classes.modal}
            style={{
              maxHeight: "90vh",
              maxWidth: 900,
              width: "90%",
              overflowY: "auto",
              overflowX: "hidden",
              padding: "16px 24px 24px 24px",
            }}
          >
            <h2 style={{ textAlign: "center", fontSize: "18px", marginTop: 0 }}>
              Detalle de Cobranza
            </h2>

            {/* ── Tabla de información general ── */}
            <div style={{ marginBottom: "15px" }}>
              <table className={classes.infoTable}>
                <tbody>
                  <tr>
                    <td data-label="true" style={{ width: "14%", backgroundColor: "#BFD9FF", fontWeight: "bold" }}>ESTADO:</td>
                    {/* <td style={{ width: "18%", color: cobranza.estado === "P" ? "blue" : cobranza.estado === "R" ? "red" : "green" }}>
                      {cobranza.estado === "P" ? "PENDIENTE" : cobranza.estado === "R" ? "RECHAZADO" : cobranza.estado === "A" ? "APROBADO" : "REVISADO"}
                    </td> */}
                    <td className={classes.infoValor} style={{width: '18%', textAlign: 'center'}}>
                        <BadgeEstado estado={cobranza.estado} classes={classes} />
                    </td>
                    <td data-label="true" style={{ width: "12%", backgroundColor: "#BFD9FF", fontWeight: "bold" }}>FECHA:</td>
                    <td style={{ width: "18%" }}>{cobranza.fechaCobranza}</td>
                    <td data-label="true" style={{ width: "14%", backgroundColor: "#BFD9FF", fontWeight: "bold" }}>COMPROBANTE:</td>
                    <td style={{ width: "24%" }}>
                      {cobranza.foto01 === null || cobranza.foto01 === ""
                        ? <Button startIcon={<Icon className="fa fa-ban" />} color="primary" size="small" />
                        : <a href={cobranza.foto01} target="_blank" rel="noreferrer"><Button startIcon={<Icon className="fa fa-camera" />} color="primary" size="small" /></a>
                      }
                      {cobranza.foto02 === null || cobranza.foto02 === ""
                        ? <Button startIcon={<Icon className="fa fa-ban" />} color="primary" size="small" />
                        : <a href={cobranza.foto02} target="_blank" rel="noreferrer"><Button startIcon={<Icon className="fa fa-camera" />} color="primary" size="small" /></a>
                      }
                    </td>
                  </tr>
                  <tr>
                    <td data-label="true" style={{ backgroundColor: "#BFD9FF", fontWeight: "bold" }}>NIT:</td>
                    <td><b>{cobranza.nit}</b></td>
                    <td data-label="true" style={{ backgroundColor: "#BFD9FF", fontWeight: "bold" }}>CLIENTE:</td>
                    <td>{cobranza.cliente}</td>
                    <td data-label="true" style={{ backgroundColor: "#BFD9FF", fontWeight: "bold" }}>RESPONSABLE:</td>
                    <td>{cobranza.responsable ? cobranza.responsable.toUpperCase() : ""}</td>
                  </tr>
                  <tr>
                    <td data-label="true" style={{ backgroundColor: "#BFD9FF", fontWeight: "bold" }}>OBSERVACIÓN:</td>
                    <td colSpan="5">{cobranza.observacion ? cobranza.observacion.toUpperCase() : ""}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* ── Tabla de información bancaria ── */}
            <div style={{ marginBottom: "15px" }}>
              <table className={classes.infoBankTable}>
                <tbody>
                  <tr>
                    <td data-label="true" style={{ width: "14%", backgroundColor: "#EBE5B7", fontWeight: "bold" }}>BANCO:</td>
                    <td style={{ width: "18%" }}>{cobranza.banco ? cobranza.banco.toUpperCase() : ""}</td>
                    <td data-label="true" style={{ width: "14%", backgroundColor: "#EBE5B7", fontWeight: "bold" }}>NRO CUENTA:</td>
                    <td style={{ width: "18%" }}>{cobranza.numeroCuenta}</td>
                    <td data-label="true" style={{ width: "14%", backgroundColor: "#EBE5B7", fontWeight: "bold" }}>NRO OPERACIÓN:</td>
                    <td style={{ width: "22%" }}>{cobranza.nroDocumento}</td>
                  </tr>
                  <tr>
                    <td data-label="true" style={{ backgroundColor: "#EBE5B7", fontWeight: "bold" }}>FECHA OPERACIÓN:</td>
                    <td>{cobranza.fecha}</td>
                    <td data-label="true" style={{ backgroundColor: "#EBE5B7", fontWeight: "bold" }}>TIPO COBRANZA:</td>
                    <td>{cobranza.tipoCobranza}</td>
                    <td data-label="true" style={{ backgroundColor: "#EBE5B7", fontWeight: "bold" }}>TOTAL COBRANZA:</td>
                    <td>{formatoPeru("en-US", "USD", cobranza.total)}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            {/* ── Tabla de documentos (scroll horizontal) ── */}
            {datad.length !== 0 && (
              <div className={classes.docsTableWrap}>
                <div style={{ display: "none" }}>
                  {!loading && datad.map((ite) => (total = total + ite.monto))}
                </div>
                <table className="aprobacion" id="tableMod">
                  <thead>
                    <tr>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Nro. Documento</th>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Fecha</th>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Fecha Vence</th>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Saldo</th>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Monto</th>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Retención</th>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Tipo Retención</th>
                      <th style={{ backgroundColor: "#e3f2fd", padding: "8px", border: "1px solid #BFD2E9", fontSize: "10px", whiteSpace: "nowrap" }}>Descuento</th>
                    </tr>
                  </thead>
                  <tbody style={{ border: "1px solid #BFD2E9" }}>
                    {!loading &&
                      datad.map((item, index) => (
                        <tr style={{ backgroundColor: "Gainsboro" }} key={index}>
                          <td className={classes.resul} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{item.nroDocumento}</td>
                          <td className={classes.resul} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{item.fecha}</td>
                          <td className={classes.resul} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{item.fechaVence}</td>
                          <td className={classes.resuld} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{formatoPeru("en-US", "USD", item.saldo)}</td>
                          <td className={classes.resuld} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{formatoPeru("en-US", "USD", item.monto)}</td>
                          <td className={classes.resuld} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{formatoPeru("en-US", "USD", item.retencion)}</td>
                          <td className={classes.resul} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{item.dRetencion}</td>
                          <td className={classes.resuld} style={{ padding: "6px", border: "1px solid #BFD2E9", whiteSpace: "nowrap" }}>{formatoPeru("en-US", "USD", item.descuento)}</td>
                        </tr>
                      ))}
                    {datad.length > 0 && !loading && (
                      <tr key={1000} style={{ backgroundColor: "white" }}>
                        <td className={classes.resuld} colSpan="8" style={{ padding: "8px", textAlign: "right", border: "1px solid #BFD2E9" }}>
                          <b style={{ fontSize: "12px" }}>Total: {formatoPeru("en-US", "USD", total)}</b>
                        </td>
                      </tr>
                    )}
                    {datad.length === 0 && !loading && (
                      <tr key={1}>
                        <td className={classes.resul} colSpan="8" style={{ padding: "6px" }}>
                          No existe Registro
                        </td>
                      </tr>
                    )}
                  </tbody>
                  {loading && (
                    <tbody>
                      <tr>
                        <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                          <img
                            alt="log"
                            src="https://app.iess.gob.ec/iess-fondo-reserva-afiliado-web/javax.faces.resource/images/load.gif.jsf;jsessionid=8949b76cfea43d283add3bd3dd2d?ln=sentinel-layout"
                            width="40"
                            height="40"
                          />
                        </td>
                      </tr>
                    </tbody>
                  )}
                </table>
              </div>
            )}

            {/* ── Detalle de envío ── */}
            {cobranza.fechaEnvio != null && (
              <div style={{ marginBottom: "20px" }}>
                <h2 style={{ fontSize: "18px", marginBottom: "10px" }}>Detalle de envío</h2>
                <table className={classes.infoTable}>
                  <tbody>
                    <tr>
                      <td data-label="true" style={{ width: "18%", backgroundColor: "#BFD9FF", fontWeight: "bold" }}>CODIGO ORIGEN:</td>
                      <td style={{ width: "20%" }}><b>{cobranza.codigoOrigen}</b></td>
                      <td data-label="true" style={{ width: "12%", backgroundColor: "#BFD9FF", fontWeight: "bold" }}>ESTADO:</td>
                      <td style={{ width: "18%" }}><b>{cobranza.estadoEnvio === 1 ? "ENVIADO" : "NO ENVIADO"}</b></td>
                      <td data-label="true" style={{ width: "15%", backgroundColor: "#BFD9FF", fontWeight: "bold" }}>FECHA:</td>
                      <td style={{ width: "17%" }}>{cobranza.fechaEnvio}</td>
                    </tr>
                    <tr>
                      <td data-label="true" style={{ backgroundColor: "#BFD9FF", fontWeight: "bold" }}>RESPUESTA DE ENVIO:</td>
                      <td colSpan="5" style={{ wordBreak: "break-word" }}><b>{cobranza.respuesta}</b></td>
                    </tr>
                    <tr>
                      <td data-label="true" style={{ backgroundColor: "#BFD9FF", fontWeight: "bold", verticalAlign: "top" }}>JSON ENVIADO:</td>
                      <td colSpan="5">
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
                          <span style={{ flex: 1, wordBreak: "break-all" }}>
                            <b>{truncateText(cobranza.jsonEnviado, 150) || "N/A"}</b>
                          </span>
                          {cobranza.jsonEnviado && cobranza.jsonEnviado.length > 150 && (
                            <Button
                              variant="outlined"
                              color="primary"
                              size="small"
                              style={{ fontSize: "10px", padding: "2px 8px", textTransform: "none", minWidth: "70px" }}
                              onClick={HandleOpenJson}
                            >
                              Ver más
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

                {/* Modal del JSON */}
                <Modal open={showJsonModal} onClose={HandleCloseJson} aria-labelledby="json-modal-title">
                  <div
                    style={{
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      position: "absolute",
                      maxHeight: "85vh",
                      maxWidth: 700,
                      width: "90%",
                      backgroundColor: "white",
                      boxShadow: "0px 11px 15px -7px rgba(0,0,0,0.2)",
                      borderRadius: "15px",
                      padding: "24px",
                      overflowY: "auto",
                    }}
                  >
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "15px" }}>
                      <h2 style={{ margin: 0, fontSize: "18px" }}>JSON Enviado</h2>
                    </div>
                    <div
                      style={{
                        backgroundColor: "#f5f5f5",
                        padding: "15px",
                        borderRadius: "8px",
                        fontSize: "12px",
                        fontFamily: "monospace",
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                        overflowX: "auto",
                        marginTop: "10px",
                        border: "1px solid #ddd",
                      }}
                    >
                      {formatJson(cobranza.jsonEnviado)}
                    </div>
                    <div style={{ marginTop: "20px", textAlign: "right" }}>
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={() => {
                          navigator.clipboard.writeText(formatJson(cobranza.jsonEnviado));
                          HandleCloseJson();
                          HandleClose();
                          dispatch(
                            openMessageBox({
                              button: "ok",
                              icon: "info",
                              message: "JSON copiado al portapapeles",
                              callback: () => dispatch(closeMessageBox()),
                            })
                          );
                        }}
                        style={{ marginRight: "10px" }}
                      >
                        Copiar
                      </Button>
                      <Button variant="outlined" onClick={HandleCloseJson}>
                        Cerrar
                      </Button>
                    </div>
                  </div>
                </Modal>
              </div>
            )}

            {/* ── Botón cerrar sticky ── */}
            <div
              style={{
                position: "sticky",
                bottom: 0,
                backgroundColor: "white",
                paddingTop: "15px",
                paddingBottom: "10px",
                textAlign: "right",
                marginLeft: "-24px",
                marginRight: "-24px",
                paddingRight: "24px",
                borderTop: "1px solid #e0e0e0",
              }}
            >
              <Button variant="contained" color="primary" onClick={HandleClose} className={classes.bot}>
                Cerrar
              </Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  };

  function BadgeEstado({ estado, classes }) {
    const mapa = {
        P: { cls: classes.estadoPendiente, txt: 'PENDIENTE' },
        A: { cls: classes.estadoAprobado,  txt: 'APROBADO'  },
        R: { cls: classes.estadoRechazado, txt: 'RECHAZADO' },
    };
    const cfg = mapa[estado] ?? { cls: classes.estadoRevisado, txt: 'REVISADO' };
    return <span className={cfg.cls}>{cfg.txt}</span>;
  }

  return (
    <FieldSet className={classes.root} iconCls="fas fa-th-list" title="Resultados">
      <div style={{ display: "none" }}>
        <ReactHTMLTableToExcel
          id="table-xls-button-rpt-cobranza"
          className=""
          table="table-to-xls"
          filename="Rpt_cobranza"
          sheet="Cobranza"
          buttonText=""
        />
      </div>

      <div className={classes.tableWrap}>
        <Table
          columns={columns}
          count={store.total}
          loading={loading}
          onRowClick={(items) => {}}
          onRowDoubleClick={(items) => handleDoubleClick(items)}
          onSort={(datakey) => handleRequestSort(datakey)}
          onUpdateColumn={handleResizeColumn}
          rowCount={store.data.length}
          rowGetter={(index) => store.data[index]}
          selected={store.selected}
          sortBy={orderBy}
          sortDirection={order}
          noRowsRenderer={() => <div>hola</div>}
        />
      </div>
      <div className="App">{show ? <ModalContent /> : null}</div>
    </FieldSet>
  );
}

export default ReporteCobranzaList;